import React from "react";
import WithdrawPageSection from "../sections/WithdrawPageSection/Content";
const WithdrawPage = () => {
  return <WithdrawPageSection />;
};

export default WithdrawPage;
